import * as actionTypes from '@/store/action-types'
import * as getTypes from '@/store/get-types'
import * as mutationTypes from '@/store/mutation-types'
import { directPaymentType } from '@/components/direct-payments/direct-payment-constants'

const state = {
  amount: null,
  paymentType: null,
  sessionId: null,
  utid: null
}

const getters = {
  [getTypes.GET_DIRECT_PAYMENT_AMOUNT]: ({ amount }) => amount,
  [getTypes.GET_DIRECT_PAYMENT_TYPE]: ({ paymentType }) => paymentType,
  [getTypes.GET_DIRECT_PAYMENT_SESSION_ID]: ({ sessionId }) => sessionId,
  [getTypes.GET_DIRECT_PAYMENT_UTID]: ({ utid }) => utid
}

const actions = {
  [actionTypes.SET_DIRECT_PAYMENT_AMOUNT]: ({ commit }, amount) => {
    commit(mutationTypes.SET_DIRECT_PAYMENT_AMOUNT, Number(amount))
  },
  [actionTypes.SET_DIRECT_PAYMENT_SESSION_ID]: ({ commit }, sessionId) => {
    commit(mutationTypes.SET_DIRECT_PAYMENT_SESSION_ID, sessionId)
  },
  [actionTypes.SET_DIRECT_PAYMENT_TYPE]: ({ commit }, paymentType) => {
    const newPaymentType = directPaymentType[paymentType] || null
    commit(mutationTypes.SET_DIRECT_PAYMENT_TYPE, newPaymentType)
  },
  [actionTypes.SET_DIRECT_PAYMENT_UTID]: ({ commit }, utid) => {
    commit(mutationTypes.SET_DIRECT_PAYMENT_UTID, utid)
  }
}

const mutations = {
  [mutationTypes.SET_DIRECT_PAYMENT_AMOUNT]: (state, amount) => {
    state.amount = amount
  },
  [mutationTypes.SET_DIRECT_PAYMENT_SESSION_ID]: (state, sessionId) => {
    state.sessionId = sessionId
  },
  [mutationTypes.SET_DIRECT_PAYMENT_TYPE]: (state, paymentType) => {
    state.paymentType = paymentType
  },
  [mutationTypes.SET_DIRECT_PAYMENT_UTID]: (state, utid) => {
    state.utid = utid
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
